import type { FeedbackTier } from "../../../../common/types.ts";

export type { FeedbackTier };

export const DEFAULT_FEEDBACK_TIER: FeedbackTier = "toast";

// Any unrecognized / missing tier falls back to the legacy toast channel so old
// events and events that never set a tier keep the existing snackbar behavior.
export const resolveFeedbackChannel = (
	tier: FeedbackTier | undefined,
): FeedbackTier => {
	if (tier === "highlight" || tier === "moment") {
		return tier;
	}
	return DEFAULT_FEEDBACK_TIER;
};

// The player-emotion moments from MOBILE_GAME_FEEL_PLAN_2026-07-08.md §5. Each
// moment maps to the feedback tier it should surface at, plus whether its engine
// event has actually been wired. G1a wired draftPick; G1c wired phaseChange;
// N4-1 wired championship / clinchedPlayoffs / signing / trade / playerFeat /
// fired (plus playoff-series advancement, which reuses the clinchedPlayoffs
// highlight tier and has no dedicated key here). madePlayoffs and ownerWarning
// stay `wired: false` until their events are changed.
export type FeedbackMomentKey =
	| "championship"
	| "madePlayoffs"
	| "clinchedPlayoffs"
	| "draftPick"
	| "signing"
	| "trade"
	| "playerFeat"
	| "ownerWarning"
	| "fired"
	| "phaseChange";

export type FeedbackMomentSpec = {
	tier: FeedbackTier;
	wired: boolean;
};

export const FEEDBACK_MOMENT_TIERS: Record<
	FeedbackMomentKey,
	FeedbackMomentSpec
> = {
	championship: { tier: "moment", wired: true },
	madePlayoffs: { tier: "highlight", wired: false },
	clinchedPlayoffs: { tier: "highlight", wired: true },
	draftPick: { tier: "highlight", wired: true },
	signing: { tier: "highlight", wired: true },
	trade: { tier: "highlight", wired: true },
	playerFeat: { tier: "highlight", wired: true },
	ownerWarning: { tier: "highlight", wired: false },
	fired: { tier: "moment", wired: true },
	phaseChange: { tier: "moment", wired: true },
};

export const wiredFeedbackMoments = (): FeedbackMomentKey[] =>
	(Object.keys(FEEDBACK_MOMENT_TIERS) as FeedbackMomentKey[]).filter(
		(key) => FEEDBACK_MOMENT_TIERS[key].wired,
	);
